import actions from "./actions";
import formular from "./formular";
import login from "./login";
import scan from "./scan";
import common from "./common";


export default {
  actions,
  common,
  errors: {
    token_invalid: {
      headline: "Token ungültig",
      text: "Der benutzte Token ist nicht gültig"
    },
    unexpected: {
      headline: "Unerwarteter Fehler",
      text: "Es ist ein unerwarteter Fehler aufgetreten"
    },
    validation_failure: {
      headline: "Fehlende oder Fehlerhafte Eingaben",
      text: "Es gibt fehlerhafte oder fehlende Eingaben. Bitte überprüfen Sie das Formular"
    }
  },
  formular,
  login,
  scan,
  success: {
    formular_saved: {
      headline: "Formular gespeichert",
      text: "Das Formular wurde erfolgreich gespeichert"
    }
  }
}
